import React, { useState } from "react";
import { Button, Col, Form, InputGroup, Row } from "react-bootstrap";
import FilePicker from "common/ui/FilePicker";
import contractSignatureService, { RequestContractSignatureRequest } from "./contractSignatureService";
import ModalWrapper from "common/ui/Modal";
import { useHelloSign } from "./useHelloSign";
import notificationService from "common/notificationService";
import ValidationError from "common/validationError";

type RequestContractSignatureProps = {
    contractDisplayId: string;
    contractId: string;
    notificationSuccessMessage: string;
    onClose(): void;
    onFinish?(): void;
};

const RequestContractSignatureModal: React.FC<RequestContractSignatureProps> = (props: RequestContractSignatureProps) => {
    const [contractFile, setContractFile] = useState<File>();

    const { openHelloSign } = useHelloSign({
        onFinish: () => {
            notificationService.success(props.notificationSuccessMessage);
            props.onFinish?.();
        }
    });

    const isValid = contractFile?.name.length > 0;

    async function onSubmit(): Promise<void> {
        const request: RequestContractSignatureRequest = {
            contractFile: contractFile,
        };
        try {
            const claimUrl = await contractSignatureService.requestContractSignature(props.contractId, request);
            openHelloSign(claimUrl);
        }
        catch (error) {
            notificationService.error(((error as ValidationError).errors ?? ["An unknown error occurred"])[0]);
        }
        finally {
            props.onClose();
        }
    }

    return <ModalWrapper
        title="Request Contract Signature"
        isAdvanceButtonDisabled={!isValid}
        onAdvance={() => onSubmit()}
        advanceButtonText="Submit"
        async
        onCancel={props.onClose}>
        <div className="container mt-2">
            <Form.Group as={Row}>
                <Form.Label column className="required pl-0">Contract ID#:</Form.Label>
                <Col sm="8">
                    <Form.Control type="text" value={props.contractDisplayId} readOnly plaintext />
                </Col>
            </Form.Group>
            <Form.Group as={Row}>
                <Form.Label className="required">Contract File:</Form.Label>
                <InputGroup>
                    <Form.Control
                        name="file-name"
                        type="text"
                        defaultValue={contractFile?.name}
                        readOnly={true}
                    />
                    {!contractFile &&
                        <FilePicker
                            onFilePicked={(files: File[]) => setContractFile(files[0])}
                            acceptTypes="application/pdf"
                            maxFiles={1} />
                    }
                    {contractFile && <Button className="text-decoration-none d-flex align-items-center" variant="link"
                        onClick={() => setContractFile(null)}>
                        <i className="material-icons">delete</i> Delete File
                    </Button>}
                </InputGroup>
            </Form.Group>
        </div>
    </ModalWrapper>;
}


export default RequestContractSignatureModal;